(function(angular){
    'use strict';

    var validationKey = 'apMultiSelectButton';

    angular.module('aprima-core-ui').factory('ApMultiSelectButton', [
        '_',
        ApMultiSelectButton,
    ]);

    function ApMultiSelectButton(
        _
    ) {
        var service = {
            init: init,
        };

        return service;
        

        function init(ctrl, onOpen, itemFormatter, orderFn, element) {
            itemFormatter = itemFormatter || _.identity;
            orderFn = orderFn || _.identity;

            ctrl.innerValue = undefined;
            ctrl.onClick = onClick;
            ctrl.$onInit = onInit;


            function onInit() {
                ctrl.ngModelCtrl.$isEmpty = isEmpty;
                ctrl.ngModelCtrl.$render = render;
                ctrl.ngModelCtrl.$formatters.push(defaultFormatterParser);
                ctrl.ngModelCtrl.$parsers.push(defaultFormatterParser);
            }

            function render() {
                var value = ctrl.ngModelCtrl.$viewValue;

                if(_.isArray(value)) {
                    var resultValue = _(value)
                        .sortBy(orderFn)
                        .map(itemFormatter)
                        .join(', ');

                    ctrl.innerValue = resultValue;

                    return;
                }

                ctrl.innerValue = undefined;
            }

            function isEmpty(value) {
                return !value || !value.length;
            }

            function onClick() {
                if(!ctrl.ngModelCtrl) {
                    return;
                }

                onOpen(ctrl.ngModelCtrl.$viewValue)
                    .then(function(result) {
                        ctrl.ngModelCtrl.$setViewValue(result || []);
                        ctrl.ngModelCtrl.$render();
                    })
                    .finally(function() {
                        // after closing, don't keep button focused
                        if(element) {
                            element.blur();
                        }
                    });
            }

            function defaultFormatterParser(value) {
                if(_.isNil(value)) {
                    ctrl.ngModelCtrl.$setValidity(validationKey, true);
                    return null;
                }

                if(!_.isArray(value)) {
                    ctrl.ngModelCtrl.$setValidity(validationKey, false);
                    return null;
                }

                // cloneDeep so that mutating an object in either array won't have side effects on the other one
                var newArray = _(value)
                    .filter(itemFormatter)
                    .cloneDeep();

                // if the filtered array is the same length, then there are no invalid items
                if(newArray.length === value.length) {
                    ctrl.ngModelCtrl.$setValidity(validationKey, true);
                }
                else {
                    ctrl.ngModelCtrl.$setValidity(validationKey, false);
                }

                return newArray;
            }
        }
    }

})(window.angular);